import { z } from 'zod'

export const SystemCatalogItemStatusSchema = z.number().transform((value) => {
  switch (value) {
    case 0:
      return 'Inactive'
    case 1:
      return 'Active'
    default:
      throw new Error('Invalid item status values')
  }
})

export const ProviderCategorySchema = z.object({
  id: z.number(),
  status: SystemCatalogItemStatusSchema,
  code: z.string().nullable(),
  name: z.string(),
  description: z.string().nullable(),
  created_datetime: z.string().nullable(),
  last_datetime: z.string().nullable(),
})

export type ProviderCategory = z.infer<typeof ProviderCategorySchema>

export const CreateProviderCategorySchema = z.object({
  name: z.string(),
})
export type CreateProviderCategory = z.infer<
  typeof CreateProviderCategorySchema
>

export const UpdateProviderCategorySchema = z.object({
  name: z.string(),
  status: z.union([z.literal(0), z.literal(1)]),
})
export type UpdateProviderCategory = z.infer<
  typeof UpdateProviderCategorySchema
>
